module.exports = __webpack_public_path__ + "static/media/arrow2.055e1e65.svg";